module.exports = require("./../../_gen/starling/events/TouchEvent");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/events/TouchEvent.js
// module id = 186
// module chunks = 0